import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import { getPagePath } from '../../common/helpers/faqPathHelper';
import dataAids from '../../common/constants/dataAids';

const DEFAULT_MISC_TOPIC_NAME = 'Miscellaneous';

class ViewArticle extends Component {
  static get propTypes() {
    return {
      article: PropTypes.object.isRequired,
      backClickHandler: PropTypes.func.isRequired,
      staticContent: PropTypes.object,
      miscTopicName: PropTypes.string
    };
  }

  constructor() {
    super(...arguments);
    this.onBackClick = this.onBackClick.bind(this);
  }

  onBackClick(e) {
    const { backClickHandler } = this.props;
    if (backClickHandler) {
      e.preventDefault();
      backClickHandler();
    }
  }

  render() {
    const { article, staticContent = {} } = this.props;
    const { allArticles = 'All Articles' } = staticContent;

    const styles = {
      container: {
        maxWidth: '800px',
        margin: '0 auto'
      },
      backLink: {
        marginBottom: 'xlarge'
      },
      title: {
        marginBottom: 'medium'
      },
      topicLabel: {
        marginBottom: 'large',
        color: 'highlight',
        textTransform: 'uppercase',
        fontSize: 'small'
      },
      content: {
        'marginTop': 'large',
        'lineHeight': 1.6,
        'color': 'section',
        '> a, a': {
          color: 'highlight'
        },
        '> p': {
          marginBottom: 'medium'
        },
        'img': {
          maxWidth: '100%',
          height: 'auto'
        },
        'table': {
          width: '100%'
        },
        'td': {
          width: '50%'
        }
      }
    };

    return (
      <UX2.Element.Block style={ styles.container }>
        <UX2.Element.MoreLink.Backward
          style={ styles.backLink }
          href={ getPagePath() }
          onClick={ this.onBackClick }
          data-aid={ dataAids.FAQ_BACK_LINK }
        >
          { allArticles }
        </UX2.Element.MoreLink.Backward>

        <UX2.Element.Details style={ styles.topicLabel } data-aid={ dataAids.FAQ_ARTICLE_TOPIC }>
          { article.topic?.name || this.props.miscTopicName || DEFAULT_MISC_TOPIC_NAME }
        </UX2.Element.Details>

        <UX2.Element.Heading tag='h1' style={ styles.title } data-aid={ dataAids.FAQ_ARTICLE_TITLE }>
          { article.title }
        </UX2.Element.Heading>

        <UX2.Element.Block
          style={ styles.content }
          data-aid={ dataAids.FAQ_ARTICLE_BODY }
          dangerouslySetInnerHTML={{ __html: article.body }}
        />
      </UX2.Element.Block>
    );
  }
}

export default ViewArticle;
